import { Routes, Route } from 'react-router-dom'
import { Home } from './Home'
import { About } from './About'
import { Temp } from './Temp'
import { ProjectPage } from './Project'
import { Services } from './Services'
import { ContactPage } from './Contact'
import { PrivacyPolicy } from './PrivacyPolicy'

const Main = () => (
    <Routes>
        <Route
            path='/'
            element={
                <>
                    <Home />
                </>
            }
        ></Route>
        <Route
            path='/about'
            element={
                <>
                    <About />
                </>
            }
        ></Route>

        <Route
            path='/contact'
            element={
                <>
                    <ContactPage />
                </>
            }
        ></Route>

        <Route
            path='/policy'
            element={
                <>
                    <PrivacyPolicy />
                </>
            }
        ></Route>

        <Route
            path='/temp'
            element={
                <>
                    <Temp />
                </>
            }
        ></Route>

        <Route
            path='/services'
            element={
                <>
                    <Services />
                </>
            }
        ></Route>

        <Route
            path='/:projectId'
            element={
                <>
                    <ProjectPage />
                </>
            }
        ></Route>
    </Routes>
)

export default Main
